module.exports = __webpack_public_path__ + "static/media/caros-italic.ccb0fa74.woff";